import { render, staticRenderFns } from "./CartCustomer.vue?vue&type=template&id=032d3f97"
import script from "./CartCustomer.vue?vue&type=script&lang=js"
export * from "./CartCustomer.vue?vue&type=script&lang=js"
import style0 from "./CartCustomer.vue?vue&type=style&index=0&id=032d3f97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports